import { render, staticRenderFns } from "./TextTemplate.vue?vue&type=template&id=054be8cc&"
import script from "./TextTemplate.vue?vue&type=script&lang=js&"
export * from "./TextTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054be8cc')) {
      api.createRecord('054be8cc', component.options)
    } else {
      api.reload('054be8cc', component.options)
    }
    module.hot.accept("./TextTemplate.vue?vue&type=template&id=054be8cc&", function () {
      api.rerender('054be8cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/TextTemplate.vue"
export default component.exports